import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AsyncStaffListComponent, AsyncStaffCreateComponent, AsyncStaffDetailComponent, AsyncStaffModifyComponent } from 'Components/AsyncComponent/AsyncComponent';

const Staff = () => {
  const location = useLocation();
  if (location.pathname === '/admin/staff') {
    return <Navigate to='/admin/staff/list' />;
  }
  return (
    <div className='content-wrapper'>
      <Routes>
        <Route path='list' element={<AsyncStaffListComponent />} />
        <Route path='create' element={<AsyncStaffCreateComponent />} />
        <Route path='detail/:id' element={<AsyncStaffDetailComponent />} />
        <Route path='modify/:id' element={<AsyncStaffModifyComponent />} />
      </Routes>
    </div>
  );
};

export default Staff;
